export class ColModels {
    
    constructor() {
        this.UsersModel = [
            new Column("username", "Email", "string"),
            new Column("role", "Access", "roles", 200),
            new Column("fName", "First Name", "string", 80),
            new Column("lName", "Last Name", "string", 80)
        ]
    }

    UsersModel: Column[];

}

class Column {
    col: any;

    intFilters: string[] = ["ge", "le", "gt", "lt", "eq", "ne"];
    strFilters: string[] = ["cn", "nc", "eq", "ne", "bw", "bn", "in", "ni", "ew", "en"];
    dateFilters: string[] = ["ge", "le", "gt", "lt", "eq", "ne"];
    boolFilters: string[] = ["eq", "ne"];

    label: string;
    name: string;
    width: number;
    search: boolean;
    fixed: boolean;
    hidden: boolean;
    searchoptions: any;
    stype: string;
    sorttype: string;
    value: string;
    sortable: boolean;

    formatter?: any;
    formatoptions?: any;
    datefmt?: string;

    constructor(
        key: string,
        label: string,
        type: string,
        width: number = 150,
        hidden: boolean = false,
        sortable: boolean = true,
        editable: boolean = false,
        filter: boolean = false
    ) {
        let value = "";
        this.stype = "text";
        this.sorttype = "text";
        switch (type) {
            case "int":
                this.sorttype = "float"; break;
            case "bool":
                this.stype = "select";
                value = ":;1:True;0:False"; break;
            case "date":
                this.sorttype = "date"; break;
            case "permission":
                this.formatter = function (cellValue, options, rowObject) {
                    switch (rowObject.Permission) {
                        case 1: return "Admin";
                        case 2: return "Regular";
                    }
                }; break;
            case "checkbox":
                type = "bool";
                this.formatter = function (cellValue, options, rowObject) {
                    return '<div class="grid-checkbox-container"><input type="checkbox" class="grid-checkbox" id="' + options.gid + '-checkbox-' + rowObject.id + '" checked /></div>';
                }; break;
            case "roles":
                type = "string";
                this.formatter = function (cellValue, options, rowObject) {
                    try {
                        if (cellValue)
                            return JSON.parse(cellValue).join(", ");
                        else
                            return "";
                    } catch (e) {
                        console.error(e);
                        return "";
                    }
                }; break;
        }
        this.label = label;
        this.name = key;
        this.width = width;
        this.search = filter;
        this.fixed = true;
        this.hidden = hidden;
        this.sortable = sortable;
        this.searchoptions = {
            sopt: this[type + "Filters"],
            value: value
        }
        if (type == "date") {
            this.formatter = "date";
            this.formatoptions = {
                srcformat: "Y-m-d",
                newformat: "Y-m-d H:i:s A"
            }
            this.datefmt = "Y-m-d";
        }


    }

}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./App/Classes/ColModels.ts